import './AppBar.css';

class AppBar {
    /**
     * Our tool should be placed at the Toolbox, so describe an icon and title
     */
    static get toolbox() {
        return {
            title: 'AppBar',
            icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 11H6V9H18V11Z" fill="#000000" /><path fill-rule="evenodd" clip-rule="evenodd" d="M2 16C2 17.6569 3.34315 19 5 19H19C20.6569 19 22 17.6569 22 16V8C22 6.34315 20.6569 5 19 5H5C3.34315 5 2 6.34315 2 8V16ZM5 17H19C19.5523 17 20 16.5523 20 16V8C20 7.44772 19.5523 7 19 7H5C4.44772 7 4 7.44771 4 8V16C4 16.5523 4.44772 17 5 17Z" fill="#000000"/></svg>'
        };
    }

    /**
     * Allow render Image Blocks by pasting HTML tags, files and URLs
     * @see {@link https://editorjs.io/paste-substitutions}
     * @return {{tags: string[], files: {mimeTypes: string[], extensions: string[]}, patterns: {image: RegExp}}}
     */
    static get pasteConfig() {
        return {
            tags: ['IMG'],
            files: {
                mimeTypes: ['image/*'],
                extensions: ['gif', 'jpg', 'png'] // You can specify extensions instead of mime-types
            },
            patterns: {
                image: /https?:\/\/\S+\.(gif|jpe?g|tiff|png)$/i
            }
        };
    }

    /**
     * Automatic sanitize config
     * @see {@link https://editorjs.io/sanitize-saved-data}
     */
    static get sanitize() {
        return {
            // url: {},
            // caption: {
            //     b: true,
            //     a: {
            //         href: true
            //     },
            //     i: true
            // }
        }
    }

    /**
     * Tool class constructor
     * @param {ImageToolData} data — previously saved data
     * @param {object} api — Editor.js Core API {@link  https://editorjs.io/api}
     * @param {ImageToolConfig} config — custom config that we provide to our tool's user
     */
    constructor({ data, block, api, config }) {
        this.api = api;
        this.blockAPI = block;
        this.config = config || {};
        this.data = {
            mainMenu: data.mainMenu,
            titulo: data.titulo || '',
            headerMenu: data.headerMenu || '',
            login: data.login,
            profile: data.profile,
            darkMode: data.darkMode,
            denseMode: data.denseMode,
            iconColorLight: data.iconColorLight,
            iconColorDark: data.iconColorDark,
        };
        this.wrapper = undefined;        
    }

    /**
   * Return a Tool's UI
   * @return {HTMLElement}
   */
    render() {
        this.wrapper = document.createElement('div');
        this.wrapper.classList.add('app-bar');

        this.wrapper.appendChild( document.createElement('div')).outerHTML = 
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">'+
        '<path d="M4 6H20M4 12H20M4 18H20" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'+
        '</svg>';

        const input = document.createElement('input');
        input.type="checkbox";
        input.id="appBar-mainMenu";
        input.checked=this.data.mainMenu;

        this.wrapper.appendChild(input);

        let divider = document.createElement('div');
        divider.classList.add('verticalDivider');

        this.wrapper.appendChild(divider);

        const inputT = document.createElement('input');
        inputT.id="appBar-titulo";
        inputT.value = this.data.titulo;
        inputT.addEventListener('change', (event) => {        
            this.changeSomeDataProperty()
        });

        let l = document.createElement("label");
        l.for = 'titulo';
        l.innerHTML = 'Título da pagina: ';
        this.wrapper.appendChild(l);
        this.wrapper.appendChild(inputT);
        
        divider = document.createElement('div');
        divider.classList.add('verticalDivider');
        this.wrapper.appendChild(divider);

        const inputM = document.createElement('input');
        inputM.id="appBar-menu";
        inputM.value = this.data.headerMenu;
        inputM.addEventListener('change', (event) => {        
            this.changeSomeDataProperty()
        });

        l = document.createElement("label");
        l.for = 'menu';
        l.innerHTML = 'Menu Header: ';
        this.wrapper.appendChild(l);
        this.wrapper.appendChild(inputM);

        divider = document.createElement('div');
        divider.classList.add('verticalDivider');
        this.wrapper.appendChild(divider);

        // LOGIN/LOGOFF
        this.wrapper.appendChild( document.createElement('div')).outerHTML = 
        '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2.00098 11.999L16.001 11.999M16.001 11.999L12.501 8.99902M16.001 11.999L12.501 14.999" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.3531 21.8897 19.1752 21.9862 17 21.9983M9.00195 17C9.01406 19.175 9.11051 20.3529 9.87889 21.1213C10.5202 21.7626 11.4467 21.9359 13 21.9827" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>';

        let ck = document.createElement('input');
        ck.type="checkbox";
        ck.id="appBar-loginLogout";
        ck.checked=this.data.login;
        ck.addEventListener('change', (event) => {        
            this.changeSomeDataProperty()
        });

        this.wrapper.appendChild(ck);

        divider = document.createElement('div');
        divider.classList.add('verticalDivider');
        this.wrapper.appendChild(divider);

        // profile
        this.wrapper.appendChild( document.createElement('div')).outerHTML = 
        '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g clip-path="url(#clip0_15_82)"> <rect width="24" height="24" fill="white"></rect> <g filter="url(#filter0_d_15_82)"> <path d="M14.3365 12.3466L14.0765 11.9195C13.9082 12.022 13.8158 12.2137 13.8405 12.4092C13.8651 12.6046 14.0022 12.7674 14.1907 12.8249L14.3365 12.3466ZM9.6634 12.3466L9.80923 12.8249C9.99769 12.7674 10.1348 12.6046 10.1595 12.4092C10.1841 12.2137 10.0917 12.022 9.92339 11.9195L9.6634 12.3466ZM4.06161 19.002L3.56544 18.9402L4.06161 19.002ZM19.9383 19.002L20.4345 18.9402L19.9383 19.002ZM16 8.5C16 9.94799 15.2309 11.2168 14.0765 11.9195L14.5965 12.7737C16.0365 11.8971 17 10.3113 17 8.5H16ZM12 4.5C14.2091 4.5 16 6.29086 16 8.5H17C17 5.73858 14.7614 3.5 12 3.5V4.5ZM7.99996 8.5C7.99996 6.29086 9.79082 4.5 12 4.5V3.5C9.23854 3.5 6.99996 5.73858 6.99996 8.5H7.99996ZM9.92339 11.9195C8.76904 11.2168 7.99996 9.948 7.99996 8.5H6.99996C6.99996 10.3113 7.96342 11.8971 9.40342 12.7737L9.92339 11.9195ZM9.51758 11.8683C6.36083 12.8309 3.98356 15.5804 3.56544 18.9402L4.55778 19.0637C4.92638 16.1018 7.02381 13.6742 9.80923 12.8249L9.51758 11.8683ZM3.56544 18.9402C3.45493 19.8282 4.19055 20.5 4.99996 20.5V19.5C4.70481 19.5 4.53188 19.2719 4.55778 19.0637L3.56544 18.9402ZM4.99996 20.5H19V19.5H4.99996V20.5ZM19 20.5C19.8094 20.5 20.545 19.8282 20.4345 18.9402L19.4421 19.0637C19.468 19.2719 19.2951 19.5 19 19.5V20.5ZM20.4345 18.9402C20.0164 15.5804 17.6391 12.8309 14.4823 11.8683L14.1907 12.8249C16.9761 13.6742 19.0735 16.1018 19.4421 19.0637L20.4345 18.9402Z" fill="#000000"></path> </g> </g> <defs> <filter id="filter0_d_15_82" x="2.55444" y="3.5" width="18.8911" height="19" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"> <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood> <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix> <feOffset dy="1"></feOffset> <feGaussianBlur stdDeviation="0.5"></feGaussianBlur> <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix> <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15_82"></feBlend> <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15_82" result="shape"></feBlend> </filter> <clipPath id="clip0_15_82"> <rect width="24" height="24" fill="white"></rect> </clipPath> </defs> </g></svg>';
        ck = document.createElement('input');
        ck.type="checkbox";
        ck.id="appBar-profile";
        ck.checked=this.data.profile;

        ck.addEventListener('change', (event) => {        
            this.changeSomeDataProperty()
        });

        this.wrapper.appendChild(ck);

        //darkMode
        this.wrapper.appendChild( document.createElement('div')).outerHTML = 
        '<svg width="24px" height="24px" viewBox="0 0 48 48" id="b" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><defs><style>.c{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}</style></defs><path class="c" d="m32.8,29.3c-8.9-.8-16.2-7.8-17.5-16.6-.3-1.8-.3-3.7,0-5.4.2-1.4-1.4-2.3-2.5-1.6C6.3,9.7,2.1,16.9,2.5,25c.5,10.7,9,19.5,19.7,20.4,10.6.9,19.8-6,22.5-15.6.4-1.4-1-2.6-2.3-2-2.9,1.3-6.1,1.8-9.6,1.5Z"></path></g></svg>';

        ck = document.createElement('input');
        ck.type="checkbox";
        ck.id="appBar-darkMode";
        ck.checked=this.data.darkMode;
        ck.addEventListener('change', (event) => {        
            this.changeSomeDataProperty()
        });
        this.wrapper.appendChild(ck);

        //denseMode
        this.wrapper.appendChild( document.createElement('span')).outerHTML = "Dense";
        ck = document.createElement('input');
        ck.type="checkbox";
        ck.id="appBar-denseMode";
        ck.checked=this.data.denseMode;
        ck.addEventListener('change', (event) => {        
            this.changeSomeDataProperty()
        });
        this.wrapper.appendChild(ck);


        return this.wrapper;
    }

    changeSomeDataProperty() {        
        // Tell Editor to know that block was changed
        this.blockAPI.dispatchChange();
      }

    /**
   * Extract data from the UI
   * @param {HTMLElement} blockContent — element returned by render method
   * @return {SimpleImageData}
   */
    save(blockContent) {        
        const mainMenu = blockContent.querySelector('#appBar-mainMenu').checked;
        const titulo =   blockContent.querySelector('#appBar-titulo').value;
        const inputM =   blockContent.querySelector('#appBar-menu').value;
        const login =    blockContent.querySelector('#appBar-loginLogout').checked;
        const profile =  blockContent.querySelector('#appBar-profile').checked;
        const darkMode =  blockContent.querySelector('#appBar-darkMode').checked;
        const denseMode =  blockContent.querySelector('#appBar-denseMode').checked;

        return Object.assign(this.data, {
            mainMenu: mainMenu,
            titulo: titulo,
            headerMenu: inputM,
            login: login,
            profile: profile,
            darkMode: darkMode,
            denseMode: denseMode,
        });
    }

    /**
   * Skip empty blocks
   * @see {@link https://editorjs.io/saved-data-validation}
   * @param {ImageToolConfig} savedData
   * @return {boolean}
   */
    validate(savedData) {
        // if (!savedData.url.trim()) {
        //     return false;
        // }

        return true;
    }

    /**
   * @see https://editorjs.io/making-a-block-settings — tutorial
   * @see https://editorjs.io/tools-api#rendersettings - API method description
   * @return {HTMLDivElement}
   */
    renderSettings() {
        const wrapper = document.createElement('div');
        let button = document.createElement('button');
        button.classList.add(this.api.styles.settingsButton);
        // button.classList.add(this.api.styles.block);
        button.innerHTML = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>';
        
        let l = document.createElement("label");        
        l.innerHTML = 'Editar';
        button.appendChild(l);

        wrapper.appendChild(button);

        button.addEventListener('click', () => {            
            this.config.setOpen(true);
            this.config.setData({
                tipo: 'AppBar',
                data: this.data
            });            
        });
        
        return wrapper;
    }

    /**
   * @private
   * Click on the Settings Button
   * @param {string} tune — tune name from this.settings
   */
    // _toggleTune(tune) {
    //     this.data[tune] = !this.data[tune];
    //     this._acceptTuneView();
    // }

    /**
   * Add specified class corresponds with activated tunes
   * @private
   */
    // _acceptTuneView() {
    //     console.log( this.settings );

    //     this.settings.forEach(tune => {
    //         this.wrapper.classList.toggle(tune.name, !!this.data[tune.name]);

    //         if (tune.name === 'stretched') {
    //             this.api.blocks.stretchBlock(this.api.blocks.getCurrentBlockIndex(), !!this.data.stretched);
    //         }
    //     });
    // }

   /**
   * Handle paste event
   * @see https://editorjs.io/tools-api#onpaste - API description
   * @param {CustomEvent }event
   */
    onPaste(event) {
        console.log( event );

        // switch (event.type) {
        //     case 'tag':
        //         const imgTag = event.detail.data;
        //         this._createImage(imgTag.src);
        //         break;
        //     case 'file':
        //         /* We need to read file here as base64 string */
        //         const file = event.detail.file;
        //         const reader = new FileReader();

        //         reader.onload = (loadEvent) => {
        //             this._createImage(loadEvent.target.result);
        //         };

        //         reader.readAsDataURL(file);
        //         break;
        //     case 'pattern':
        //         const src = event.detail.data;

        //         this._createImage(src);
        //         break;
        // }
    }
}

export default AppBar;